import { getStorage, ref as storageRef, getDownloadURL } from 'firebase/storage';

export const SET_STATE = (state, { key, value }) => {
  state[key] = value;
};

export const INITIALIZE = (state) => {
  state.isInitialized = true;
};

export const RESET_STATE = (state) => {
  if (state.unsubOrgs) {
    state.unsubOrgs();
    state.unsubOrgs = null;
  }
  state.organizations = [];
  state.isInitialized = false;
  state.error = null;
  state.isLoading = false;
  state.userOrganization = {};
};

export const SET_ORG_SELECTED = async (state, { organization, isInit }) => {
  try {
    const localOrg = localStorage.getItem('organization');
    state.selectedOrganization = isInit ? (localOrg || organization) : localOrg;
    const org = isInit ? organization : state.organizations.find((e) => e.id === state.selectedOrganization);
    if (!org) {
      state.userOrganization = { orgLogoLink: null };
      return;
    }
    state.userOrganization = { ...org };
    let l = org.orgLogoLink;
    if (!l) {
      state.userOrganization.orgLogoLink = null;
      return;
    }
    if (l.startsWith('http')) {
      const m = l.match(/https:\/\/storage.googleapis.com\/[\w.-]+\/(.+)/);
      l = decodeURIComponent(m && m[1] ? `/${m[1]}` : l);
    }
    state.userOrganization.orgLogoLink = await getDownloadURL(storageRef(getStorage(), l));
  } catch (e) {
    state.userOrganization.orgLogoLink = null;
    console.error('[MUTATION] Error setting orgLogoLink:', e);
  }
};

export const SET_USER_ORGANIZATION = async (state, { organization, isInit }) => {
  await SET_ORG_SELECTED(state, { organization, isInit });
};
